export default "__VITE_ASSET__MYC0rwHv__"